import { render, staticRenderFns } from "./switch-field.vue?vue&type=template&id=6a6631d2&scoped=true"
import script from "./switch-field.vue?vue&type=script&lang=js"
export * from "./switch-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6631d2",
  null
  
)

export default component.exports